import axios from "axios";


export default axios.create({
    baseURL:'https://maintenance.argos-v19.itmsol.fr/'
})